var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wd-100p ht-50 dp-flex jus-c cr-hui3 bg-hei ft-s14 Roboto"},[_c('img',{staticClass:"ht-40 mg-r10",attrs:{"src":require('@/assets/foot.png')}}),_vm._v(" © 2022 Frasers Hospitality Pte Ltd. A member of Frasers Property Group. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }